
import React from 'react'
import { Clear } from "@mui/icons-material"

import "./customicons.css"

export const CancelIconSmall = ({ disabled, onClick }) => {

  return (
   
    <div>
      <Clear className= "iconCancel" sx={{  paddingBottom: '5px', cursor:'pointer', color:'red' }} onClick = {onClick}/>
    </div> 

  )
}
  




